import { render, staticRenderFns } from "./ChMedia.vue?vue&type=template&id=612e7798&scoped=true"
import script from "./ChMedia.vue?vue&type=script&lang=js"
export * from "./ChMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e7798",
  null
  
)

export default component.exports